import { Box } from '@mui/material';
import { GridToolbarContainer } from '@mui/x-data-grid-pro';
import {
  GridToolbarColumnsButton,
  type GridToolbarColumnsButtonProps,
} from './grid-toolbar-columns-button';
import { GridToolbarSearch } from './grid-toolbar-search';
import { GridToolbarResetButton } from './grid-toolbar-reset-button';

export type GridToolbarProps = GridToolbarColumnsButtonProps;

export function GridToolbar(props: GridToolbarProps) {
  const { columns } = props;

  return (
    <GridToolbarContainer>
      <GridToolbarSearch />
      <GridToolbarColumnsButton columns={columns} />
      <GridToolbarResetButton />
      <Box sx={{ flex: 1 }} />
    </GridToolbarContainer>
  );
}
